import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./SaveConfirmationPopup.scss";

const SaveConfirmationPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleSaveSuccess = () => {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 2000);
    };

    window.addEventListener("saveSuccess", handleSaveSuccess);
    return () => {
      window.removeEventListener("saveSuccess", handleSaveSuccess);
    };
  }, []);

  if (!visible) return null;

  return createPortal(
    <div className="save_confirmation_overlay" onClick={() => setVisible(false)}>
      <div
        className="save_confirmation_popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="save_confirmation_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle cx="12" cy="12" r="12" fill="#38A169" />
            <path
              d="M7 12.5L10.5 16L17 9"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="save_confirmation_text">Your changes are saved</p>
      </div>
    </div>,
    document.body
  );
};

export default SaveConfirmationPopup;
